import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, take } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UpdateService {
    private swUpdate = inject(SwUpdate);

    constructor() {
    //     if (this.swUpdate.isEnabled) {
    //         console.log('enable');
    //         this.swUpdate.versionUpdates.subscribe(() => {
    //             const lastUpdateTime = localStorage.getItem('lastUpdateTime');
    //             const now = Date.now();

    //             // Only reload if it hasn't reloaded in the last 5 minutes
    //             if (!lastUpdateTime || now - parseInt(lastUpdateTime, 10) > 5 * 60 * 1000) {
    //                 localStorage.setItem('lastUpdateTime', now.toString());

    //                 //if (confirm('New update available! Reload to update?')) {
    //                     window.location.reload();
    //                 //}
    //             }
    //         });
    //     }
    // }
    if (this.swUpdate.isEnabled) {
        this.swUpdate.versionUpdates
          .pipe(
            filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
            take(1) // 👈 ensures it only triggers once
          )
          .subscribe(() => {
            const lastUpdateTime = parseInt(localStorage.getItem('lastUpdateTime') || '0', 10);
            const now = Date.now();
    
            if (!lastUpdateTime || now - lastUpdateTime > 2 * 60 * 1000) {
              localStorage.setItem('lastUpdateTime', now.toString());
              if (confirm('New update available! Reload to update?')) {
              window.location.reload();
              }
            }
          });
      }
    }
}
